







































import Vue from 'vue';
import { Prop, Model, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ISelectOption from '@frontend/types/base/ISelectOption';
import ArrowDownSVG from '@assets/svg/arrow-down.svg';

@Component({
	componentId: 'C021',
	components: {
		ArrowDownSVG
	},
	inheritAttrs: false
})
export default class SelectInput extends Vue {
	@Prop(String)
	protected readonly id!: string;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop(String)
	protected readonly label?: string;

	@Prop(String)
	protected readonly prompt?: string;

	@Prop(Array)
	protected readonly options!: ISelectOption[];

	@Model('change', { type: String, default: '' })
	protected value!: string;

	@Prop({ type: Boolean, default: false })
	protected readonly hasError!: boolean;

	@Prop({ type: Boolean, default: false })
	protected readonly hideLabel!: boolean;

	/**
	 * Controls whether the "selected" attribute for options should be set.
	 * Prevents jumping selections when multiple options have the same value.
	 */
	protected setSelectedOnRender: boolean = true;

	/**
	 * The value of the recent selected <option>.
	 */
	protected selectedOptionValue: string | null = null;

	protected labelLong: boolean = false;

	protected mounted(): void {
		if (this.label) {
			const label = this.$refs.fieldLabel as HTMLElement;
			if (label) {
				const isMultiLine = label.scrollHeight > label.clientHeight;
				if (isMultiLine) {
					this.labelLong = true;
				}
			}
		}
		const selectedOption: HTMLOptionElement | null = this.$el.querySelector(`option[value="${this.value}"`);

		if (selectedOption) {
			// Set attribute on mount (again) because it's not kept on client side rendering and otherwise a form reset would switch to the first enabled option
			selectedOption.setAttribute('selected', 'selected');
		}
	}

	protected get inputId(): string {
		return `${this.id || this.uid}-input`;
	}

	protected get isRequired(): boolean {
		return this.$attrs.required !== undefined && this.$attrs.required !== 'false';
	}

	protected onChange(event: Event): void {
		this.selectedOptionValue = (event.target as HTMLInputElement).value;
		this.setSelectedOnRender = false;
		this.$emit('change', this.selectedOptionValue);
	}

	@Watch('value', { immediate: true })
	protected onValueChange(value: string, oldValue: string): void {
		if (value !== oldValue && value !== this.selectedOptionValue) {
			// If the value has changed and is not already selected, allow the "selected" attribute to be set
			// Otherwise don't allow it, so we have no jumping selections if multiple options have the same value.
			this.setSelectedOnRender = true;
		}
	}

	@Watch('options', { deep: true })
	protected onOptionsChange(): void {
		this.setSelectedOnRender = true;
	}
}
